import React from 'react';
import { Dialog, DialogContent, IconButton, DialogTitle } from '@mui/material';
import { useStyles } from './style';
import { TableComponents, Icons } from 'components';
import useCustomHook from '../../hooks';
import LoanServices from '../../services/LoanServices';
import { columns, generateData } from './components/Columns';
import axios from 'axios';
import { useCurrencyUnit } from 'hooks';

export default function LoanInstallmentDialog({ open, setOpen, loanId }) {
  const classes = useStyles();
  const { loading, setLoading, size, setSize, page, setPage } = useCustomHook();
  const currencyText = useCurrencyUnit();
  const getLoanInstallmentList = async (query) => {
    setLoading(true);
    try {
      const params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query?.pageSize || size,
        loanId,
      };
      const res = await LoanServices.getInstallmentList(params);

      let list = [];
      if (res.result) {
        list = generateData(res.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }
      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      setLoading(false);
      return d;
    } catch (e) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  return (
    <>
      <Dialog
        onClose={() => setOpen(false)}
        aria-labelledby="simple-dialog-title"
        fullWidth
        maxWidth="md"
        open={open}
        className={classes.dialogMain}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={() => setOpen(false)}
          className={classes.title}
        >
          لیست اقساط
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => setOpen(false)}
          >
            <Icons icon="Close" color="#939393" size="20" />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          {currencyText && (
            <TableComponents
              data={getLoanInstallmentList}
              columns={columns(currencyText)}
              isLoading={loading}
              onChange={(ps) => {
                setPage(ps?.pageNumber);
                setSize(ps?.pageSize);
                return getLoanInstallmentList(ps);
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
